import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app-wrapper" };
const _hoisted_2 = { class: "sidebar-container" };
const _hoisted_3 = { class: "main-container" };
const _hoisted_4 = { class: "header-container" };
const _hoisted_5 = { class: "content-container" };
import Sidebar from './components/Sidebar.vue';
import Header from './components/Header.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(Header)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_router_view)
                    ])
                ])
            ]));
        };
    }
});
